// extracted by mini-css-extract-plugin
export var button = "_1u-1";
export var featuredLink = "_1u-4";
export var spinner = "_1u-2";
export var spinnerContainer = "_1u-3";
export var text = "_1u-0";